// extracted by mini-css-extract-plugin
export var actionText = "_lw-4";
export var container = "_lw-0";
export var leftSection = "_lw-1";
export var rightSection = "_lw-2";
export var settingsButton = "_lw-6";
export var settingsIcon = "_lw-7";
export var shortcut = "_lw-5";
export var shortcutGroup = "_lw-3";